import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    try {
      const pixelId = '830019496771734';
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const first = document.getElementsByTagName('script')[0];
      if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first);
      } else {
        document.head.appendChild(script);
      }
      w.fbq('init', pixelId);
      w.fbq('track', 'PageView');
    } catch (e) {
      // Pixel init failed silently
    }
  }, []);
  return <div className="w-full min-h-screen bg-navy-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <WhatYouGetSection data-id="element-4" />
      <WhoIsForSection data-id="element-5" />
      <HowItWorksSection data-id="element-6" />
      <ProofSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <FooterSection data-id="element-10" />
    </div>;
}